export default "__VITE_ASSET__DIKy4nH3__"